import styled from 'styled-components';
import {
  variant,
  color,
  space,
  layout,
  flexbox,
  typography,
  grid,
} from 'styled-system';

const Text = styled.span`
  ${color};
  ${space};
  ${layout};
  ${flexbox};
  ${grid}
  font-family: 'Montserrat', sans-serif;
  ${variant({
    variants: {
      h1: {
        fontWeight: '300',
        fontSize: '52px',
        lineHeight: '64px',
        letterSpacing: '0.2px',
      },
      h2: {
        fontWeight: '500',
        fontSize: '44px',
        lineHeight: '54px',
        letterSpacing: '0px',
      },
      h3: {
        fontWeight: '600',
        fontSize: '32px',
        lineHeight: '40px',
        letterSpacing: '0.1px',
      },
      h4: {
        fontWeight: '500',
        fontSize: '26px',
        lineHeight: '32px',
        letterSpacing: '0.2px',
      },
      h5: {
        fontWeight: '600',
        fontSize: '20px',
        lineHeight: '26px',
        letterSpacing: '0.2px',
      },
      h6: {
        fontWeight: '600',
        fontSize: '18px',
        lineHeight: '24px',
        letterSpacing: '0.2px',
      },
      h7: {
        fontWeight: '500',
        fontSize: '18px',
        lineHeight: '24px',
        letterSpacing: '0.2px',
      },
      subtitle1: {
        fontWeight: '500',
        fontSize: '16px',
        lineHeight: '24px',
        letterSpacing: '0.1px',
      },
      subtitle2: {
        fontWeight: '500',
        fontSize: '14px',
        lineHeight: '18px',
        letterSpacing: '0.1px',
      },
      subtitle3: {
        fontSize: '16px',
        fontWeight: '600',
        lineHeight: '24px',
        letterSpacing: '0.1px',
      },
      body1: {
        fontWeight: '400',
        fontSize: '16px',
        lineHeight: '24px',
        letterSpacing: '0.1px',
      },
      body2: {
        fontWeight: '400',
        fontSize: '14px',
        lineHeight: '22px',
        letterSpacing: '0.1px',
      },
      body3: {
        fontWeight: '500',
        fontSize: '14px',
        lineHeight: '24px',
        letterSpacing: '0.1px',
      },
      body4: {
        fontWeight: '400',
        fontSize: '13.3333px',
        lineHeight: '21px',
        letterSpacing: '0.1px',
      },
      small1: {
        fontWeight: '500',
        fontSize: '12px',
        lineHeight: '16px',
        letterSpacing: '0.2px',
      },
      small2: {
        fontWeight: '400',
        fontSize: '12px',
        lineHeight: '16px',
        letterSpacing: '0.2px',
      },
      small3: {
        fontWeight: '400',
        fontSize: '11px',
        lineHeight: '14px',
        letterSpacing: '0.2px',
      },
      small4: {
        fontWeight: '500',
        fontSize: '10px',
        lineHeight: '18px',
        letterSpacing: '0.1px',
      },
      small5: {
        fontWeight: '600',
        fontSize: '9px',
        lineHeight: '12px',
        letterSpacing: '0.1px',
      },
      small6: {
        fontWeight: '400',
        fontSize: '9px',
        lineHeight: '12px',
        letterSpacing: '0.1px',
      },
      button: {
        fontWeight: '600',
        fontSize: '14px',
        lineHeight: '18px',
        letterSpacing: '0.2px',
      },
      initials: {
        fontWeight: '600',
        fontSize: '13px',
        lineHeight: '16px',
        letterSpacing: '0.2px',
      },
      date: {
        fontWeight: '600',
        fontSize: '12px',
        lineHeight: '16px',
      },
    },
  })};
  ${typography};
`;

Text.defaultProps = {
  color: 'black.100',
};

export default Text;
